import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../assets/pvm-logo.png';
import { CONTACT_INFO, NAV_LINKS } from '../utils/constants';
import { IconPhone, IconWhatsapp } from '../utils/icons';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className='header'>
            <div className='header-inner'>
                <Link to='/' className='logo-container' onClick={() => setMenuOpen(false)}>
                    <img className='logo-img' src={logo} alt={CONTACT_INFO.businessName} />
                    <span className='logo-text'>
                        {CONTACT_INFO.businessName}
                        <small>Manoj Kumar &middot; Financial Consultant</small>
                    </span>
                </Link>

                <button
                    className='menu-toggle'
                    aria-label='Toggle navigation menu'
                    onClick={() => setMenuOpen((open) => !open)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <nav className={`nav-items ${menuOpen ? 'open' : ''}`}>
                    <ul>
                        {NAV_LINKS.map((link) => (
                            <li key={link.path}>
                                <NavLink to={link.path} onClick={() => setMenuOpen(false)}>
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className='nav-ctas'>
                        <a className='nav-cta whatsapp' href={CONTACT_INFO.whatsappLink} target='_blank' rel='noopener noreferrer'>
                            <IconWhatsapp size={18} /> WhatsApp
                        </a>
                        <a className='nav-cta call' href={CONTACT_INFO.callLink}>
                            <IconPhone /> Call Now
                        </a>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
